import AreaGraph from "./areaGraph";

export default AreaGraph;
